import WelcomeAlert from "./WelcomeAlert"
export default WelcomeAlert
